export const VALID_BLOCKCHAINS = ['bitcoin', 'ethereum', 'solana', 'tether', 'litecoin', 'binance', 'tron'];

export const PLAN_RULES = {
  custom: { min: 1, max: 7 },
  pro: { exact: 3 },
  ultimate: { exact: 7 },
};

export const PLAN_LABELS = {
  custom: 'Custom',
  pro: 'Pro',
  ultimate: 'Ultimate',
};

export const STATUS_COLORS = {
  active: '#22c55e',
  none: '#6b7280',
  inactive: '#6b7280',
  expired: '#f97316',
  banned: '#ef4444',
  suspended: '#eab308',
  admin: '#9085e9',
};

export const SURVEY_SOURCES = ['tiktok', 'instagram', 'telegram', 'discord', 'friends', 'other'];

const GEO_DEVICE_STRING_FIELDS = ['country', 'countryCode', 'region', 'city', 'ip', 'browser', 'browserVersion', 'os', 'osVersion', 'deviceType'];

// Mirrors Luna Backend/admin/Users.js's EDITABLE_FIELD_TYPES — only used to pick the right
// inline input control; the backend re-validates everything authoritatively.
export const EDITABLE_FIELD_TYPES = {
  email: { type: 'email' },
  telegramUsername: { type: 'string' },
  status: { type: 'enum', values: ['active', 'inactive'] },
  planId: { type: 'enum', values: ['custom', 'pro', 'ultimate'], nullable: true },
  blockchains: { type: 'blockchainArray' },
  plan_expires: { type: 'timestamp', nullable: true },
  createdAt: { type: 'timestamp' },
  lastLogin: { type: 'timestamp' },
  loginCount: { type: 'number' },
  refId: { type: 'string' },
  referredBy: { type: 'string' },
  refCommission: { type: 'number' },
  'survey.completed': { type: 'boolean' },
  'survey.source': { type: 'enum', values: SURVEY_SOURCES },
  'survey.otherText': { type: 'string' },
};
for (const source of ['signupInfo', 'lastLoginInfo']) {
  for (const field of GEO_DEVICE_STRING_FIELDS) {
    EDITABLE_FIELD_TYPES[`${source}.${field}`] = { type: 'string' };
  }
}
